<template>
  <div class="GoodsItem">
    <div class="imgBox" @click="onClick(goods,categoryName)">
      <img :src="goods.imgGuide || goods.goodsImage" alt />
      <img class="soldOut" :src="require('@assets/images/allGone.png')" alt v-if="goods.bizStock === 0" />
      <Sticker v-if="goods.goodsType !== 1" :imgList="goods.stickerImgList" />
      <div
        v-if="goods.advanceSale"
        :class="[
          'desContent-active',
          'flex',
          union_isBilingual || CookiesOne && CookiesOne == 'en-US' ? 'isBilingual' : '',
        ]"
      >
        <div :class="{ 'presell-time': true }">
          {{ TLang('起发货1','my') }}{{
            new Date(goods.sendGoodsTimeStart)
              .toLocaleDateString()
              .replace(/\//g, "-")
          }}{{ TLang('起发货2','my') }}
        </div>
      </div>
      <!-- 爆炸贴图片 -->
      <!-- <Sticker v-if="goods.goodsType !== 1" :imgList="goods.stickerImgList" /> -->
      <div
        v-if="
          (goods.gray ||
          (restock && typeof goods.stockNum === 'number' && goods.stockNum === 0)) &&
          goods.bizStock === null
        "
        class="restock"
      >
        <img src="./restock.png" />
      </div>
    </div>
    <a class="goods-name line-clamp-2" :title="goods.goodsName || goods.name">
      <i
        v-for="(tag, index) in goods.tags"
        :key="index"
        :style="{ fontStyle: 'normal'}"
      >
        <SingleTag :show="tag.mktFrontType === 9005" :datas="tag" />
      </i>
      {{ goods.goodsName || goods.name }}
    </a>
    <div class="goods-flag">
      <span
        v-for="(tag, index) in goods.tags"
        :key="index"
        class="goods-item-flag"
      >
        <SingleTag :show="tagShow(tag, true)" :datas="tag" />
      </span>
    </div>
    <div class="fpp-style" v-if="goods && goods.groupItem === 'Y'">
      <FppGoodsPrice 
        :type="goods.groupItemClassStyle"
        :price="goods.groupItemPrice"
        :limitPrice="goods.groupItemPriceLimit"
        :unionIcon="union_icon || require('@assets/images/fudou.png')"
        :showSymbolIcon="goods.groupItemShowRmbSymbol"
      />
    </div>
    <div
      v-else
      :class="[
        'row-price',
        goods.tags && goods.tags.length > 0 ? 'market-row-price' : '',
      ]"
    >
      <img :src="union_icon || require('@assets/images/fudou.png')" />
      <span class="price">
        <FormatPrice
          :price="
            goods.promPrice && goods.tags && goods.tags.length > 0
              ? (goods.promPrice || 0.0) * union_scale
              : (goods.goodsPrice || goods.price || 0.0) * union_scale
          "
          size="m"
        ></FormatPrice>
      </span>
      <span v-if="goods.hasPriceTag && goods.tags && goods.tags.length === 0"
        >{{TLang('起','my')}}</span
      >
      <div class="line-price-box" v-if="goods.promPrice && goods.tags && goods.tags.length > 0">
        <img
          :src="union_icon || require('@assets/images/fudou.png')"
          alt=""
          class="fudou2"
        />
        <span class="line-price-num"
          >{{
            (
              (goods.salePrice || goods.goodsPrice || goods.price || 0) *
              union_scale
            ).toFixed(2)
          }}<span v-if="goods.hasPriceTag">{{TLang('起','my')}}</span></span
        >
      </div>
      <div
        v-if="purchaseType === 1 && goods.goodsType !== 1 && goods.bizStock != 0"
        class="add-btn"
        @click.stop="onClickAdd"
      >
        <i class="el-icon-plus"></i>
      </div>
    </div>
    <div class="discountPriceWrap">
      <DiscountPrice
        :discountPrice="goods.discountPrice"
        :discount="goods.discount"
        :discountTagShow="goods.discountTagShow"
        :mktTagShow="goods.mktTagShow"
        page="page"
      />
    </div>
  </div>
</template>

<script>
import Sticker from '@components/sticker';
import SingleTag from '@components/singleTag';
import FppGoodsPrice from '@components/FppGoodsPrice';
import DiscountPrice from '../DiscountPrice';
import Cookies from 'js-cookie';
export default {
  components: {
    Sticker,
    DiscountPrice,
    SingleTag,
    FppGoodsPrice,
  },
  props: {
    goods: Object,
    categoryName: String,
    onClick: Function,
    onClickAdd: Function,
    purchaseType: {
      type: Number,
      default: function () {
        return 1;
      },
    },
    restock: {
      type: Boolean,
      default: function () {
        return true;
      },
    },
    page:{
      type:String,
      default:function(){
        return ''
      }
    }
  },
  created(){
    console.log("goods", this.goods);
  },
  data() {
    return {
      CookiesOne:Cookies.get('df_lang'),
    };
  },
  methods: {
    tagShow(item, limitFlag) {
      let flag = false;
      // mktIcon 特价、限购、新品 || limitFlag && mktFrontType限购起购 || mktFrontType 300001
      if (item.mktIcon || (limitFlag && (item.mktFrontType === 9003 || item.mktFrontType === 9004))) {
        flag = true;
      }
      return flag;
    },
  },
};
</script>

<style lang="less" scoped>
.GoodsItem {
  // padding: 5px 10px;
  width: 230px;
  overflow: hidden;
  img[lazy="loading"] {
    background: #ededed;
  }
  img[lazy="error"] {
    /*your style here*/
    background: #ededed;
  }
  .imgBox {
    width: 200px;
    height: 200px;
    // padding: 0 15px;
    box-sizing: border-box;
    position: relative;
    margin: 0 auto;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      transition: all 600ms ease;
    }
    .soldOut{
      position: absolute;
      width: 110px;
      height: 110px;
      min-height: auto;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 10
    }
    .restock {
      position: absolute;
      width: 110px;
      height: 110px;
      min-height: auto;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .desContent-active {
      position: absolute;
      bottom: 0;
      width: 100%;
      line-height: 24px;
      color: rgba(255, 255, 255, 1);
      box-sizing: border-box;
      background: url("./../../../assets/images/presale.png");
      background-size: 200px 24px;
      background-repeat: no-repeat;
      .presell-time {
        line-height: 24px;
        text-align: center;
        border-radius: 0px 4px 0px 0px;
        flex: 1;
        white-space: nowrap;
        font-size: 12px;
        font-family: Tahoma;
        margin-left: 60px;
      }
    }
    .isBilingual {
      background-image: url("./../../../assets/images/presale-en.png");
    }
    &:hover img {
      // transition: all 600ms ease;
      // transform: scale(1.2,1.2);
      cursor: pointer;
    }
  }
  .goods-name {
    padding: 0 15px;
    font-size: 14px;
    color: rgba(34, 34, 34, 1);
    line-height: 20px;
    margin-top: 5px;
    height: 40px;
  }
  .row-price {
    padding: 0 15px;
    margin-top: 6px;
    display: flex;
    align-items: baseline;
    img {
      width: 16px;
      height: 16px;
      margin-top: 8px;
    }
    .price {
      font-size: 20px;
      color: rgba(244, 69, 69, 1);
      margin-left: 4px;
      margin-right: 5px;
    }
    .add-btn {
      margin-left: auto;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      line-height: 22px;
      background: linear-gradient(
        315deg,
        rgba(92, 180, 236, 1) 0%,
        rgba(61, 150, 226, 1) 100%
      );
      box-shadow: 0px 2px 4px 0px rgba(61, 150, 226, 0.4);
      margin-top: 4px;
    }
    .line-price-box {
      margin-top: 4px;
      position: relative;
      .fudou2 {
        width: 8px;
        height: 8px;
        /* margin-left: 6px; */
        margin-top: 0;
        vertical-align: middle;
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: grayscale(100%);
        filter: gray;
        opacity: 0.7;
      }
      .line-price-num {
        font-size: 12px;
        /* text-decoration: line-through; */
        margin-left: -4px;
        color: #999999;
      }
      &:after {
        content: "";
        width: 106%;
        height: 1px;
        position: absolute;
        left: -1px;
        top: 11px;
        background-color: #999999;
      }
    }
  }
  .goods-flag {
    // display: flex;
    height: 16px;
    overflow: hidden;
    padding: 5px 14px 0;
  }
  .goods-item-flag {
    // width: 34px;
    width: auto;
    min-width: 32px;
    height: 16px;
    margin-right: 6px;
    float: left;
  }
  .discountPriceWrap{
    padding: 0px;
  }
  .fpp-style{
    padding: 0 15px;
    margin-top: 6px;
    font-weight: 400 !important;
  }
  
}
</style>
